import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  deleteReferral,
  getReferralsList,
  type ReferralListParams,
} from "@/apis/referral/referral-apis";
import { queryKeys } from "./keys";

export function useReferrals(params: ReferralListParams) {
  return useQuery({
    queryKey: queryKeys.referrals.list(params),
    queryFn: () => getReferralsList(params),
    placeholderData: keepPreviousData,
  });
}

export function useDeleteReferral() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: number) => deleteReferral(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.referrals.all,
        predicate: (query) => query.queryKey[1] === "list",
      });
    },
  });
}
